import React from "react";
import { DEADLINE_COLORS } from "../utils/date.ts";

interface DeadlineCountBadgesProps {
  overdue: number;
  today: number;
}

/**
 * プロジェクト一覧に表示する期限件数バッジ。
 * 赤 = 期限切れ、オレンジ = 今日が期限（サブタスクを含む未完了タスクの件数）。
 * 0 件のバッジは表示しない。
 */
export const DeadlineCountBadges: React.FC<DeadlineCountBadgesProps> = ({
  overdue,
  today,
}) => {
  if (overdue === 0 && today === 0) return null;

  const badgeClass =
    "min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold leading-none " +
    "text-white flex items-center justify-center";

  return (
    <span className="flex items-center gap-0.5 flex-shrink-0 ml-1">
      {overdue > 0 && (
        <span
          className={badgeClass}
          style={{ backgroundColor: DEADLINE_COLORS.overdue }}
          title={`期限切れ ${overdue}件`}
          aria-label={`期限切れ ${overdue}件`}
        >
          {overdue > 99 ? "99+" : overdue}
        </span>
      )}
      {today > 0 && (
        <span
          className={badgeClass}
          style={{ backgroundColor: DEADLINE_COLORS.today }}
          title={`今日が期限 ${today}件`}
          aria-label={`今日が期限 ${today}件`}
        >
          {today > 99 ? "99+" : today}
        </span>
      )}
    </span>
  );
};
